import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaRegTrashAlt } from 'react-icons/fa'
import { Btn, BtnIcon, CustomDropdown, CustomModal, NumeroDecimal } from '../../../../components'
import { isNfseVigente } from './emitirNfse.util'

const TODOS_CLIENTES = { client_id: null, nomeFantasia: 'Todos os clientes' }
const STATUS_CTE_VIGENTES = ['autorizado', 'processando_autorizacao']

// Nota da rota que cabe em NFS-e: cliente no município do Operador Logístico e sem CT-e ou NFS-e vigente
export function isNotaElegivelNfse(entrega) {
  return (
    Boolean(entrega.tp_city_id) &&
    entrega.client_city_id === entrega.tp_city_id &&
    !STATUS_CTE_VIGENTES.includes(entrega.cte_status) &&
    !isNfseVigente(entrega.nfse_status)
  )
}

function distintos(lista, campo) {
  const vistos = new Set()
  return lista.filter(item => {
    if (vistos.has(item[campo])) return false
    vistos.add(item[campo])
    return true
  })
}

export default function ModalSelecionarNotasNfse({
  visible,
  entregas,
  onClose,
  onContinuar,
  onError,
}) {
  const [empresa, setEmpresa] = useState(null)
  const [cliente, setCliente] = useState(TODOS_CLIENTES)
  const [removidas, setRemovidas] = useState([])

  const elegiveis = (entregas || []).filter(isNotaElegivelNfse)
  const empresas = distintos(elegiveis, 'company_id').map(entrega => ({
    company_id: entrega.company_id,
    company_name: entrega.company_name,
  }))
  const daEmpresa = empresa
    ? elegiveis.filter(entrega => entrega.company_id === empresa.company_id)
    : []
  const clientes = [
    TODOS_CLIENTES,
    ...distintos(daEmpresa, 'client_id').map(entrega => ({
      client_id: entrega.client_id,
      nomeFantasia: entrega.nomeFantasia,
    })),
  ]
  const notas = daEmpresa.filter(
    entrega =>
      (!cliente.client_id || entrega.client_id === cliente.client_id) &&
      !removidas.includes(entrega.delivery_id),
  )

  useEffect(() => {
    if (!visible) return
    setCliente(TODOS_CLIENTES)
    setRemovidas([])
    const unicas = distintos((entregas || []).filter(isNotaElegivelNfse), 'company_id')
    setEmpresa(
      unicas.length === 1
        ? { company_id: unicas[0].company_id, company_name: unicas[0].company_name }
        : null,
    )
  }, [visible, entregas])

  // Events
  const onBtnContinuarClicked = () => {
    if (!empresa) return onError('Selecione a Empresa')
    if (!notas.length) return onError('Mantenha pelo menos uma nota')
    onContinuar(notas.map(nota => nota.delivery_id))
  }

  // Render
  return (
    <CustomModal
      isVisible={visible}
      header="Emitir NFS-e - notas da rota"
      width={750}
      onClose={onClose}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <span style={{ color: 'gray', fontSize: 12 }}>
            Aparecem só as notas de clientes no município do Operador Logístico (frete municipal)
            que ainda não têm CT-e nem NFS-e.
          </span>
        </div>
        <div className="p-md-6 p-col-12">
          <CustomDropdown
            optionLabel="company_name"
            options={empresas}
            value={
              empresa ? empresas.find(item => item.company_id === empresa.company_id) || null : null
            }
            label="Empresa:*"
            filter={empresas.length > 5}
            onChange={value => {
              setEmpresa(value)
              setCliente(TODOS_CLIENTES)
              setRemovidas([])
            }}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <CustomDropdown
            optionLabel="nomeFantasia"
            options={clientes}
            value={clientes.find(item => item.client_id === cliente.client_id) || TODOS_CLIENTES}
            label="Cliente:"
            filter={clientes.length > 5}
            disabled={!empresa}
            onChange={value => setCliente(value)}
          />
        </div>
        <div className="p-col-12">
          <DataTable
            value={notas}
            header="Notas da NFS-e"
            emptyMessage={
              elegiveis.length
                ? 'Selecione a Empresa para listar as notas'
                : 'Nenhuma nota desta rota cabe em NFS-e'
            }
          >
            <Column field="identifier" header="Nota" style={{ width: 120 }} />
            <Column field="nomeFantasia" header="Cliente" />
            <Column field="city" header="Cidade" style={{ width: 150 }} />
            <Column
              header="Peso"
              style={{ width: 110, textAlign: 'center' }}
              body={nota => <NumeroDecimal>{nota.weightTotal}</NumeroDecimal>}
            />
            <Column
              header=""
              style={{ width: 60, textAlign: 'center' }}
              body={nota => (
                <BtnIcon onClick={() => setRemovidas(atual => [...atual, nota.delivery_id])}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
            />
          </DataTable>
        </div>
        <div className="p-col-12" style={{ display: 'flex', justifyContent: 'end' }}>
          <Btn onClick={onBtnContinuarClicked}>Continuar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}
